import { render, staticRenderFns } from "./pessoa-fisica.vue?vue&type=template&id=49588b38&"
import script from "./pessoa-fisica.vue?vue&type=script&lang=js&"
export * from "./pessoa-fisica.vue?vue&type=script&lang=js&"
import style0 from "./pessoa-fisica.vue?vue&type=style&index=0&id=49588b38&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports